import React from "react";
import { showErrorDialog, showToast } from "@SeemplicityDev/shared";

interface ManualTicketData {
  link?: string;
  external_id?: string;
  ticketManagerFriendlyName?: string;
}

export interface ManualTicketError {
  message?: string;
}

export interface ManualTicketMappingData {
  message?: string;
}

export interface UseManualTicketReturn {
  onSuccess: (ticketData?: ManualTicketData) => void;
  onError: (error?: ManualTicketError) => void;
  onCreateMapping: (data?: ManualTicketMappingData) => void;
  onCreateMappingError: (error?: ManualTicketError) => void;
}

const useManualTicket = (): UseManualTicketReturn => {
  const onSuccess = (ticketData?: ManualTicketData) => {
    const message = (
      <div className={"modal-text"} data-testid={"ticket-created-msg"}>
        The Ticket{" "}
        <span className="modal-live-text">
          <a href={ticketData?.link} target="_blank" rel="noreferrer">
            {ticketData?.external_id}
          </a>{" "}
        </span>
        was successfully saved to
        <span className="modal-live-text">
          {" "}
          {ticketData?.ticketManagerFriendlyName}
        </span>
      </div>
    );
    showToast({ message });
  };

  const onError = (error?: ManualTicketError) => {
    showErrorDialog({ message: error?.message });
  };

  const onCreateMapping = (data?: ManualTicketMappingData) => {
    showToast({ message: data?.message });
  };

  const onCreateMappingError = (error?: ManualTicketError) => {
    showErrorDialog({ message: error?.message });
  };

  return {
    onSuccess,
    onError,
    onCreateMapping,
    onCreateMappingError,
  };
};

export default useManualTicket;
